import { render, staticRenderFns } from "./BAutocompleteFile.vue?vue&type=template&id=57338fb2&"
import script from "./BAutocompleteFile.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports